import { useEffect, useState } from "react";
import { DashboardSummaryRow } from "../../types/DashboardSummaryRow";
import { useIotDeviceEvents } from "./useIotDeviceEvents";
import { IotDeviceEventSummaryDto } from "./dtos/IotDeviceEventSummaryDto";
import { iotDeviceEvents } from "../../data/iotDeviceEvents.data";
import { DashboardSummary } from "../../components/DashboardSummary";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { useVspPortalCookies } from "../../hooks/useVspPortalCookies";
import { Dashboard } from "../../enums/Dashboard";


const compareDashboardSummaryRows = ( a: DashboardSummaryRow, b: DashboardSummaryRow ) => {

   
    if ( a.item < b.item ){
      
        return -1;

    }
    
    if ( a.item > b.item ){
      
        return 1;

    }

    return 0;

}


const getRows = ( iotDeviceEventsSummary: IotDeviceEventSummaryDto[] ): DashboardSummaryRow[] => {

    const rows: DashboardSummaryRow[] = [];

    for( const iotDeviceEventSummary of iotDeviceEventsSummary ) {

        rows.push( { count: iotDeviceEventSummary.deviceCount, icon: <QuestionMarkIcon />, text: '', item: iotDeviceEventSummary.status  } );

    }

    // missing events
    const events = rows.map( r => r.item );
    for( const iotDeviceEvent of iotDeviceEvents ) {

        if( !events.includes( iotDeviceEvent.event )) {

            rows.push( { count: 0, icon: <QuestionMarkIcon />, text: '', item: iotDeviceEvent.event  } );

        }

    }

    // sorting
    rows.sort( compareDashboardSummaryRows );

    // formatting
    const formattedRows: DashboardSummaryRow[ ] = [ ];

    for( const row of rows ) {

        const iotDeviceEvent = iotDeviceEvents.find( be => be.event === row.item );

        if( !iotDeviceEvent ) {
            
            throw Error( `IotDevice event ${row.item} not found` );

        }

        formattedRows.push ({ 
            count: row.count,
            icon: iotDeviceEvent.icon,
            text: iotDeviceEvent.displayedText,
            item: row.item 
        });

    }

    return formattedRows;

};


type IotDeviceEventsSummaryProps = {

    onEventsSelected( events: string[ ] ): void;
    refreshCount: number;
    villageCode: string;

};


export const IotDeviceEventsSummary: React.FC<IotDeviceEventsSummaryProps> = ( props: IotDeviceEventsSummaryProps ) => {

    const { onEventsSelected, refreshCount, villageCode } = props;

    const [ selectedEvents, setSelectedEvents ] = useState< string[] >( [] );
    const [ rows, setRows ] = useState<DashboardSummaryRow[ ]>( [ ] );
    const [ isLoading, setIsLoading ] = useState<boolean>( false );

    const { getIotDeviceEventsSummary } = useIotDeviceEvents( );

    const { getEventsCookies, getVillageCookies } = useVspPortalCookies( );


    useEffect( ( ) => {

        if( !villageCode ) {

            return;

        }
        
        const fetchIotDeviceEventsSummary = async ( ) => {

            if( refreshCount === 0 ) {
                
                setIsLoading( true );
            }

            const eventsSummary = await getIotDeviceEventsSummary( villageCode );
            
            if( refreshCount === 0 ) {
            
                setIsLoading( false );

            }

            if( eventsSummary && eventsSummary.length > 0 ) {
                
                const rows: DashboardSummaryRow[] = getRows( eventsSummary ); 
                setRows( rows );

                const villageCookie = getVillageCookies( Dashboard.IotDevice );
                const iotDeviceEvents = getEventsCookies( Dashboard.IotDevice );

                if( villageCookie && villageCookie === villageCode && iotDeviceEvents ) {

                    setSelectedEvents( iotDeviceEvents );
                    onEventsSelected( iotDeviceEvents );
        
                } else {

                    setSelectedEvents( [] );
    
                }

            } else {

                setRows( [] );
                setSelectedEvents( [] );

            }

        };
        
        fetchIotDeviceEventsSummary( );

    }, [ villageCode, refreshCount ]);


    return (

        <DashboardSummary header="Status" footer="No Of Devices" isLoading={isLoading} refreshCount={refreshCount} rows={rows} checkedItems={selectedEvents} disabledItems={ [ ] } onItemsSelected={onEventsSelected} />

    );

};